import { APIBaseUrl } from "./../../../config/constants";

export const MODULE_ENDPOINT = `${APIBaseUrl}`;